import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

function initials(title: string) {
  return String(title || '?').trim().slice(0, 1).toUpperCase() || '?'
}

export function ContactsSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className={`md-subs-contacts-row flex h-16 min-h-16 items-center border-b border-[#f0f2f5] bg-white pr-4 text-sm text-[#202124] font-[-apple-system,BlinkMacSystemFont,'Segoe_UI',Roboto,Helvetica,Arial,sans-serif] hover:bg-[#f8f9fa]${display.isChecked ? ' md-subs-contacts-row--checked bg-[#e8f0fe]' : ''}`}>
        <div className="md-subs-contacts-check flex w-9 flex-none justify-center">{controls.actions.check}</div>
        <div className="md-subs-contacts-avatar relative mr-3 flex h-10 w-10 flex-none items-center justify-center overflow-hidden rounded-full bg-[#1a73e8] text-base font-semibold text-white">
          {initials(display.identity.author || display.title)}
          {display.media.avatarPath ? <img className="absolute inset-0 h-full w-full object-cover" src={display.media.avatarPath} alt="" /> : null}
        </div>
        <div className="md-subs-contacts-main min-w-0 flex-1">
          <div className="overflow-hidden text-ellipsis whitespace-nowrap font-medium [&_.md-sub-title-link]:text-[#202124]">{controls.content.title}</div>
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-xs text-[#5f6368] [&_.md-sub-text]:inline [&_.md-sub-text]:clear-none [&_.md-sub-text]:text-[#5f6368]">{controls.content.text}</div>
        </div>
        <div className="md-subs-contacts-right ml-3 flex flex-none items-center gap-3 text-xs text-[#5f6368]">
          {controls.content.time}
          {controls.actions.favorite}
          {controls.actions.quickReply}
        </div>
      </div>
      <div className="md-subs-contacts-children ml-[88px]">{slots.allChildren}</div>
    </>
  )
}
